module.exports = "<div class=\"policy-modal-overlay\" [class.active]=\"active\" (click)=\"closeModal()\">\n  <div class=\"modal-card\" (click)=\"$event.stopPropagation()\">\n    <div class=\"information\" [innerHtml]=\"information\"></div>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/iangoldfarb/Desktop/SupplyHub/shFrontEnd/src/app/footer/policy-modal/policy-modal.component.html
// module id = ../../../../../src/app/footer/policy-modal/policy-modal.component.html
// module chunks = main